import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { useValues } from '@redlink/assets/values';
import {
  Text,
  Space,
  Card,
  IconLink,
  WrapListContainer,
} from '@redlink/components/atoms';
import { LinkTemplateItem } from '@redlink/components/molecules/linkTemplateItem';
import { useLocale } from '@redlink/assets/locale';
import { ListContainer } from '@redlink/components/organisms';

export const LinkTemplates = memo(({ onSelect, title, onAddPress }) => {
  const { styles } = useStyle();
  const { staticData } = useValues();

  return (
    <ListContainer
      title={title}
      containerContainerStyle={styles.itemsContainerStyle}
    >
      <WrapListContainer style={styles.flatList}>
        <LinkAddButton onPress={onAddPress} />
        <Space size={8} />
        {staticData.linkTemplates.map((item, index) => {
          return (
            <>
              <LinkTemplateItem {...{ item, onSelect, index }} />
              <Space size={8} />
            </>
          );
        })}
      </WrapListContainer>
    </ListContainer>
  );
});

const LinkAddButton = memo(({ onPress }) => {
  const { styles, colors } = useStyle();
  const { dictionary } = useLocale();

  return (
    <TouchableOpacity activeOpacity={0.7} {...{ onPress }}>
      <Card style={styles.linkAddButtonContainer}>
        <IconLink color={colors.red1} />
        <Space size={8} />
        <Text style={styles.titleText}>{dictionary.linkCaption}</Text>
      </Card>
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  flatList: {
    paddingBottom: 8,
  },
  linkAddButtonContainer: {
    minWidth: 70,
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemsContainerStyle: {
    marginTop: 16,
  },
  titleText: {
    color: colors.black
  }
}));
